/*
 * UI DOM element objects,
 * wrapped in jQuery wrapper
 * for reuse
 * @author: Elton Jain
*/

define('UI',['jquery'], function ($) {
    "use strict";
    
    return {
        // Document
        $b: $('body'),
        $h: $('html'),
        $hb: $('html, body'),
        $d: $(document),
        $w: $(window),

        // App
        $header: $('#header'),
        $footer: $('#footer'),
        // $appSplash: $('#appSplashScreen')

        noscroll: function (show) {
            var base = this;
            if(show === false) {
                // require(['History'], function (History) {
                    if(!window.__hstack__) {
                        base.$b.removeClass('noscroll');
                    } else if(window.__hstack__ && window.__hstack__.length === 0) {
                        /* ////////////
                         * Quick patch
                         * Considering this is an overlay popup producing noscroll
                         * ////////////
                        */
                        if(base.$h.is('.safari')) {
                            base.$h.removeClass('fixed');
                        }
                        
                        base.$b.removeClass('noscroll');
                    }
                // });
            } else {
                base.$b.addClass('noscroll');
            }
        },

        /**
         * Show back button on page header
         */
        showBackButton: function (show) {
            if(show === false) {
                this.$b.removeClass('show-back-nav');
            } else {
                this.$b.addClass('show-back-nav');
                if($('#btnNavPageBack').is('.gohome')) {
                    $('#btnNavPageBack').removeClass('gohome');
                }
            }

        }
    };
});
